<div class="gs-settings">

    <!-- Loading -->
    <div *ngIf="loading" class="gs-settings__loading">
        <div class="gs-settings__spinner"></div>
        <p>{{ 'grikySkills.admin.settings.loading' | translate }}</p>
    </div>

    <ng-container *ngIf="!loading">

        <!-- Error global -->
        <div *ngIf="error && !saving" class="gs-settings__alert gs-settings__alert--error">
            {{ error }}
        </div>

        <!-- Éxito -->
        <div *ngIf="successMessage" class="gs-settings__alert gs-settings__alert--success">
            ✓ {{ successMessage }}
        </div>

        <form [formGroup]="form" (ngSubmit)="save()">

            <!-- ── Umbrales de horas ───────────────── -->
            <div class="rounded-xl border border-gray-200 bg-white p-6 shadow-sm mb-7" formGroupName="thresholds">
                <div class="gs-settings__card-header">
                    <h2>{{ 'grikySkills.admin.settings.thresholds' | translate }}</h2>
                    <p>
                        Define cuántas horas de aprendizaje acumuladas en una habilidad
                        son necesarias para avanzar de nivel. La estimación de progresión
                        al guardar una ruta usa estos valores de forma determinista.
                    </p>
                </div>

                <div class="gs-settings__note">
                    <strong>{{ 'grikySkills.admin.settings.defaults' | translate }}</strong> (basados en estándares de aprendizaje adulto):
                    4h · 12h · 25h · 50h
                </div>

                <table class="gs-settings__table">
                    <thead>
                        <tr>
                            <th>{{ 'grikySkills.admin.settings.transition' | translate }}</th>
                            <th>{{ 'words.current-level' | translate }}</th>
                            <th>{{ 'words.target-level' | translate }}</th>
                            <th>{{ 'grikySkills.admin.settings.required-hours' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of thresholdRows">
                            <td class="gs-settings__transition">
                                {{ row.from }} → {{ row.to }}
                            </td>
                            <td>{{ row.from }}</td>
                            <td>{{ row.to }}</td>
                            <td>
                                <div class="gs-settings__input-wrap">
                                    <input
                                        type="number"
                                        [formControlName]="row.key"
                                        min="1"
                                        max="500"
                                        class="gs-settings__input"
                                        [class.invalid]="form.get('thresholds.' + row.key)?.invalid && form.get('thresholds.' + row.key)?.touched">
                                    <span class="gs-settings__unit">h</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p class="gs-settings__hint">
                    Cada umbral debe ser mayor o igual al anterior.
                    Rango permitido: 1 – 500 horas.
                </p>
            </div>

            <!-- ── Acciones ─────────────────────────────────── -->
            <div class="gs-settings__actions">
                <button
                    type="submit"
                    class="gs-settings__btn gs-settings__btn--primary"
                    [disabled]="form.invalid || saving">
                    <span *ngIf="!saving">{{ 'grikySkills.admin.settings.save' | translate }}</span>
                    <span *ngIf="saving">{{ 'words.saving' | translate }}</span>
                </button>
            </div>

        </form>
    </ng-container>

</div>
